/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Radio,
  RadioChangeEvent,
  Row,
  Select,
  Tabs,
  Upload,
  UploadProps,
} from 'antd';
import { useForm, useWatch } from 'antd/lib/form/Form';
import { cloneDeep } from 'lodash';
import { Fragment, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { IListColumn } from 'src/@types/search-params';
import { getBalance } from 'src/api/localpay';
import { uploadFilePackageAssigned } from 'src/api/package_assigned';
import {
  cancelSubcriptionOrder,
  checkListSubcriptionImport,
  checkListSubcriptionInput,
  createOrderSubcription,
  deleteRegisterPackage,
  getAllDataPackageLoad,
  getDetailSubcriptionOrder,
  submitSubcriptionData,
  updateOrderSubcription,
  waitForLoadDataJob,
} from 'src/api/register_and_cancel_and_load_package';
import BoxWithLabel from 'src/components/BoxWithLabel/BoxWithLabel';
import TableContent from 'src/components/CTable';
import ModalConfirm from 'src/components/modals/ModalComfirm';
import { usePermission } from 'src/hooks/usePermission';
import useWindowSize from 'src/hooks/useWindowSize';
import { useAppDispatch, useAppSelector } from 'src/redux/hook';
import { setGlobalState } from 'src/redux/slice/globalSlice';
import { setModalState } from 'src/redux/slice/modal.store';
import { orderStatus } from 'src/shared/common/package_assigned';
import { JOB_STATUS } from 'src/shared/constants';
import { SimStatusEnum } from 'src/shared/enum/change_sim';
import { OrderStatusEnum } from 'src/shared/enum/package_assigned';
import { ICheckInputSerialParamsRequest } from 'src/shared/interface/package_assigned';
import {
  ICreateOrderSubcriptionParams,
  IListDetailSuccessOrFail,
  ISubcriptionDataOrderList,
  IUpdateOrderSubcriptionParams,
} from 'src/shared/interface/register_and_cancel_and_load';
import {
  convertNumberByUnit,
  exportExcel,
  exportExcelPost,
  formatDateTime,
  formatMoney,
  parseQueryString,
  renderSubType,
} from 'src/utils';

type DataPackage = {
  mbfCode?: string;
  mbfName?: string;
  cycle?: number;
  dataGb?: string;
  dataUnit?: string;
  phoneNumber?: string;
};

function CreateLoadDataPackagePage() {
  const currentUrl = window.location.href;
  const size = useWindowSize();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [form] = useForm();
  const mbfCodeValue = useWatch('mbfCode', form);
  const location = useLocation();
  const { id } = parseQueryString(location.search);
  const params = parseQueryString(location.search);
  const [searchParams, setSearchParams] = useSearchParams();
  const { refresh, order, openTabs } = useAppSelector((state) => state.global);

  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [openModalConfirmDelete, setOpenModalConfirmDelete] = useState(false);
  const [openModalConfirmCancel, setOpenModalConfirmCancel] = useState(false);
  const [openModalConfirmChangeMbfCode, setOpenModalConfirmChangeMbfCode] = useState(false);
  const [openModalConfirmChangeFail, setOpenModalConfirmChangeFail] = useState(false);
  const [dataItemChangeFail, setDataItemChangeFail] = useState<DataPackage>();
  const [radio, setRadio] = useState<number>(1);
  const [isImportFile, setIsImportFile] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [statusPackage, setStatusPackage] = useState<string>(OrderStatusEnum.New);
  const [dataPackage, setDataPackage] = useState<DataPackage[]>([]);
  const [infoPackageInput, setInfoPackageInput] = useState<ISubcriptionDataOrderList>();
  const [valueSearch, setValueSearch] = useState('');
  const [selectStatus, setSelectStatus] = useState<any>(null);
  const [activeTab, setActiveTab] = useState('1');
  const [oriErros, setOriErros] = useState('');
  const [oriSuccess, setOriSuccess] = useState('');
  const [listErrors, setListErros] = useState<IListDetailSuccessOrFail[]>([]);
  const [listSuccess, setListSuccess] = useState<IListDetailSuccessOrFail[]>([]);
  const [fileImport, setFileImport] = useState<any>(null);
  const [pathFile, setPathFile] = useState<any>(null);
  const [totalData, setTotalData] = useState<number>(0);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [isChangeMbfCodeLoading, setIsChangeMbfCodeLoading] = useState(false);
  const [prevMbfCodeReg, setPrevMbfCodeReg] = useState<string | undefined>('');
  const previousValueMbfCode = useRef<string | undefined>();
  const previousValueMbfCodeReg = useRef<{ item: any; value?: string }>();
  const [totalDiscount, setTotalDiscount] = useState<number>(0);
  const [oldJobId, setOldJobId] = useState<string>();

  const { hasPermission, PERMISSIONS } = usePermission();

  useEffect(() => {
    getAllDataPackageLoad().then((res) => {
      if (res) {
        setDataPackage(res);
      }
    });
    const fetchBalance = async () => {
      const balanceRes = await getBalance();
      if (balanceRes) {
        dispatch(
          setGlobalState({ balance: balanceRes.balance, balanceData: balanceRes.balanceData }),
        );
      }
    };
    dispatch(setGlobalState({ order: undefined }));
    fetchBalance();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (statusPackage === OrderStatusEnum.Processing) {
        fetchDetailOrder();
      }
    }, 30000);
    if (statusPackage !== OrderStatusEnum.Processing) {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [statusPackage]);

  const fetchDetailOrder = async () => {
    const res = await getDetailSubcriptionOrder(id);
    if (res) {
      if (res.fileUrl) {
        setRadio(2);
        setPathFile(res.fileUrl);
      }
      const status = orderStatus.find((item) => item.value === res.statusString);
      form.setFieldsValue({
        ...res,
        type: res.type === 'Datacode' && 'Nạp data',
        statusString: status?.label ? status.label : '',
      });
      let listCheckSuccess: IListDetailSuccessOrFail[] = [];
      let listCheckFail: IListDetailSuccessOrFail[] = [];
      let totalDiscount = 0;

      if (res.statusString !== 'New') {
        listCheckSuccess = res.overFlowOrderDetailResponses
          ? res.overFlowOrderDetailResponses.filter(
              (item: IListDetailSuccessOrFail) => item.transactionFailed !== OrderStatusEnum.Failed,
            )
          : [];
        listCheckFail = res.overFlowOrderDetailResponses
          ? res.overFlowOrderDetailResponses.filter(
              (item: IListDetailSuccessOrFail) => item.transactionFailed === OrderStatusEnum.Failed,
            )
          : [];
        res.overFlowOrderDetailResponses?.forEach((item: any) => {
          if (item.extraDataObject?.discountAmount) {
            totalDiscount = totalDiscount + item.extraDataObject.discountAmount;
          }
        });
        setTotalDiscount(totalDiscount);
      } else {
        res.overFlowOrderDetailResponses?.map((item: any, index: number) => {
          if (item.statusString === OrderStatusEnum.New) {
            listCheckSuccess.push({ ...item, key: index });
          } else if (
            item.statusString === OrderStatusEnum.Failed ||
            item.transactionFailed === OrderStatusEnum.Failed
          ) {
            listCheckFail.push(item);
          } else {
            listCheckSuccess.push(item);
          }

          if (item.extraDataObject?.discountAmount) {
            totalDiscount = totalDiscount + item.extraDataObject.discountAmount;
          }
          setTotalDiscount(totalDiscount);
        });
      }
      setListSuccess(listCheckSuccess);
      setListErros(listCheckFail);
      setOriSuccess(JSON.stringify(listCheckSuccess));
      setOriErros(JSON.stringify(listCheckFail));
      dispatch(setGlobalState({ order: res }));
      setStatusPackage(res.statusString ? res.statusString.toString() : '');
      setInfoPackageInput(undefined);
      setTotalData(res.extraDataObject.totalData);
    }
  };

  useEffect(() => {
    if (id) {
      fetchDetailOrder();
    } else {
      dispatch(setGlobalState({ order: undefined }));
      form.resetFields();
    }

    return () => {
      setStatusPackage(OrderStatusEnum.New);
      dispatch(setGlobalState({ order: undefined }));
    };
  }, [id, refresh]);

  const addPhoneNumber = async (phoneNumber: number) => {
    if (form.getFieldValue('mbfCode')) {
      const params: ICheckInputSerialParamsRequest[] = [
        {
          mbfCode: form.getFieldValue('mbfCode') ?? '',
          orderId: id,
          phoneNumber: phoneNumber,
        },
      ];

      const jobRes = await checkListSubcriptionInput(params);
      if (jobRes) {
        const _oldJobId = jobRes.jobId;
        setOldJobId(_oldJobId);
        const res = await waitForLoadDataJob(_oldJobId, 'input');

        if (res && ![JOB_STATUS.Pending, JOB_STATUS.Processing].includes(res.status)) {
          const newDataSuccess: IListDetailSuccessOrFail[] = [...listSuccess];
          const newDataFailed: IListDetailSuccessOrFail[] = [...listErrors];
          if (pathFile) {
            setFileImport(null);
            setPathFile('');
            setListSuccess([]);
            setListErros([]);
            setOriSuccess('');
            setOriErros('');
          } else {
            //Xử lí duplicate
            [...res.dataSuccess].forEach((item) => {
              //Trường hợp không trùng bất cứ thằng nào.
              if (!listSuccess.some((obj) => obj.phoneNumber === item.phoneNumber)) {
                newDataSuccess.push(item);
              } else {
                const findIndex = listSuccess.findIndex(
                  (predicate) => predicate.phoneNumber === item.phoneNumber,
                );
                newDataSuccess[findIndex] = {
                  ...item,
                  errorCode: item?.errorCode ? item.errorCode : '',
                  errorMessage: item?.errorMessage ? item.errorMessage : '',
                };
              }
            });
            [...res.dataError].forEach((item) => {
              //Trường hợp không trùng bất cứ thằng nào.
              if (!listErrors.some((obj) => obj.phoneNumber === item.phoneNumber)) {
                newDataFailed.unshift(item);
              } else {
                const findIndex = listErrors.findIndex(
                  (predicate) => predicate.phoneNumber === item.phoneNumber,
                );
                newDataFailed[findIndex] = item;
              }
            });
          }
          setListSuccess(pathFile ? res.dataSuccess : newDataSuccess);
          setListErros(pathFile ? res.dataError : newDataFailed);
          setOriSuccess(
            pathFile ? JSON.stringify(res.dataSuccess) : JSON.stringify(newDataSuccess),
          );
          setOriErros(pathFile ? JSON.stringify(res.dataError) : JSON.stringify(newDataFailed));
        }
      }
    } else {
      message.warning(`Vui lòng chọn gói!`);
    }
  };

  const handleImport = async (file: any) => {
    if (radio === 2) {
      const fileImportExcel = fileImport || file;
      if (form.getFieldValue('mbfCode') && fileImportExcel) {
        const jobRes = await checkListSubcriptionImport({
          excelFile: fileImportExcel?.originFileObj
            ? fileImportExcel.originFileObj
            : fileImportExcel,
          mbfCode: form.getFieldValue('mbfCode') ?? '',
          orderId: id ? id : undefined,
        });

        if (jobRes) {
          const _oldJobId = jobRes.jobId;
          setOldJobId(_oldJobId);
          const res = await waitForLoadDataJob(_oldJobId, 'input');

          if (res && ![JOB_STATUS.Pending, JOB_STATUS.Processing].includes(res.status)) {
            const unique = res.dataError.filter(
              (obj, index) =>
                res?.dataError.findIndex((item) => item.phoneNumber === obj.phoneNumber) === index,
            );
            setListSuccess(res?.dataSuccess ?? []);
            setListErros(unique);
            setOriSuccess(JSON.stringify(res?.dataSuccess ?? []));
            setOriErros(JSON.stringify(unique));
          }
        }
        setOpenModalConfirm(false);
      } else {
        message.warning(`Vui lòng chọn gói!`);
      }
    } else {
      setOpenModalConfirm(true);
    }
    setIsImportFile(true);
  };

  const props: UploadProps = {
    beforeUpload: (file) => {
      const isPNG =
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      if (!isPNG) {
        message.error(`${file.name} không đúng định dạng`);
      }
      return isPNG;
    },
    onChange: ({ file }) => {
      if (file.status === 'removed') {
        setFileImport(null);
      } else {
        file.status = 'done';
        setFileImport(file);
        setIsImportFile(false);
      }
    },
    customRequest: async (info) => {
      if (mbfCodeValue) {
        uploadFilePackageAssigned(info.file).then((res) => {
          setPathFile(res);
        });
      } else {
        message.error(`Vui lòng chọn gói`);
      }
    },
  };

  const handleSubmit = async () => {
    const findMbfName = dataPackage.find(
      (predicate) => predicate.mbfCode === form.getFieldValue('mbfCode'),
    )?.mbfName;
    if (statusPackage === OrderStatusEnum.New) {
      if ([...listSuccess].length === 0) {
        message.error('Vui lòng import số!');
      } else {
        try {
          let getFileUrl;
          if (radio === 2) {
            if (fileImport?.originFileObj) {
              getFileUrl = await uploadFilePackageAssigned(
                fileImport?.originFileObj ? fileImport.originFileObj : fileImport,
              );
            }
          }
          const listSerial = listSuccess
            .map((item) => ({
              phoneNumber: item.phoneNumber ?? '',
              mbfCode: item.mbfCode ?? '',
            }))
            .concat(
              listErrors.map((item) => ({
                phoneNumber: item.phoneNumber ?? '',
                mbfCode: item.mbfCode ?? '',
              })),
            );
          const params: ICreateOrderSubcriptionParams = {
            mbfCode: form.getFieldValue('mbfCode') ?? '',
            mbfName: findMbfName ?? '',
            data: listSerial,
            fileUrl: radio === 2 ? (getFileUrl ? getFileUrl : undefined) : undefined,
            fileName: radio === 2 ? (fileImport ? fileImport.name : undefined) : undefined,
            methodImport: radio === 1 ? 'Input' : 'Import',
            oldJobId,
          };

          const jobRes = await createOrderSubcription(params);
          if (jobRes) {
            const res = await waitForLoadDataJob(jobRes.jobId, 'create');

            if (res && ![JOB_STATUS.Pending, JOB_STATUS.Processing].includes(res.status)) {
              const finalOrderId = res.orderId;
              if (!finalOrderId) {
                return;
              }

              form.setFieldValue('mbfCode', '');
              message.success('Lưu đơn hàng thành công!');

              const newPanes = openTabs.filter(
                (pane) => pane.key !== 'register-and-cancel-and-load-package/data-load/create',
              );

              dispatch(
                setGlobalState({
                  activeKeyMenu:
                    'register-and-cancel-and-load-package/data-load/detail' + '?id=' + finalOrderId,
                  refresh: !refresh,
                }),
              );
              if (
                !newPanes.find(
                  (tab) =>
                    tab.key ===
                    'register-and-cancel-and-load-package/data-load/detail' + '?id=' + finalOrderId,
                )
              ) {
                dispatch(
                  setGlobalState({
                    openTabs: [
                      ...newPanes,
                      {
                        label: 'Xem chi tiết Nạp data' + finalOrderId,
                        children: '',
                        key:
                          'register-and-cancel-and-load-package/data-load/detail' +
                          '?id=' +
                          finalOrderId,
                        closable: true,
                      },
                    ],
                  }),
                );
              }
              navigate(
                `/management/register-and-cancel-and-load-package/data-load/detail?id=${finalOrderId}`,
              );
            }
          }
        } catch (error) {
          console.log(error);
          // navigate(`/management/register-and-cancel-and-load-package/data-load/list`);
        }
      }
    }
    if (statusPackage === OrderStatusEnum.EDIT) {
      if (form.getFieldValue('mbfCode') && listSuccess.length > 0) {
        let getFileUrl = '';
        if (radio === 2 && fileImport) {
          getFileUrl = await uploadFilePackageAssigned(
            fileImport?.originFileObj ? fileImport.originFileObj : fileImport,
          );
        }
        const listSerial = listSuccess
          .map((item) => ({
            phoneNumber: item.phoneNumber ?? '',
            mbfCode: item.mbfCode ?? '',
          }))
          .concat(
            listErrors.map((item) => ({
              phoneNumber: item.phoneNumber ?? '',
              mbfCode: item.mbfCode ?? '',
            })),
          );

        const params: IUpdateOrderSubcriptionParams = {
          orderId: id,
          data: listSerial,
          mbfCode: form.getFieldValue('mbfCode') ?? '',
          mbfName: findMbfName ?? '',
          fileUrl:
            radio === 2 ? (getFileUrl ? getFileUrl : order?.fileUrl || undefined) : undefined,
          fileName:
            radio === 2
              ? isImportFile
                ? fileImport
                  ? fileImport.name
                  : undefined
                : order?.fileName
              : undefined,
        };
        const jobRes = await updateOrderSubcription(params);
        if (jobRes) {
          const res = await waitForLoadDataJob(jobRes.jobId, 'update');

          if (res && ![JOB_STATUS.Pending, JOB_STATUS.Processing].includes(res.status)) {
            form.setFieldValue('mbfCode', '');
            form.resetFields(['phone_number']);
            setFileImport(null);

            dispatch(setGlobalState({ refresh: !refresh }));
            setStatusPackage(OrderStatusEnum.New);
          }
        }
      } else {
        message.error('Vui lòng nhập danh sách thuê bao Huỷ gói!');
      }
    }
    setIsImportFile(false);
  };

  const handleDeletePackage = async () => {
    if (id) {
      try {
        const res = await deleteRegisterPackage(id);
        if (res) {
          message.success('Xoá đơn hàng thành công!');
          const newPanes = openTabs.filter(
            (pane) => pane.key !== 'register-and-cancel-and-load-package/data-load/detail',
          );
          dispatch(
            setGlobalState({
              activeKeyMenu: 'register-and-cancel-and-load-package/data-load/list',
            }),
          );
          if (
            !newPanes.find(
              (tab) => tab.key === 'register-and-cancel-and-load-package/data-load/list',
            )
          ) {
            dispatch(
              setGlobalState({
                openTabs: [
                  ...newPanes,
                  {
                    label: 'Đơn hàng Nạp data',
                    children: '',
                    key: 'register-and-cancel-and-load-package/data-load/list',
                    closable: true,
                  },
                ],
              }),
            );
          }
          navigate(`/management/register-and-cancel-and-load-package/data-load/list`);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleChangeMbfCode = async () => {
    if (form.getFieldValue('mbfCode')) {
      const params: ICheckInputSerialParamsRequest[] = [];
      listSuccess.forEach((item) => {
        params.push({
          mbfCode: form.getFieldValue('mbfCode') ?? '',
          orderId: id ? id : undefined,
          phoneNumber: Number(item.phoneNumber),
        });
      });
      listErrors.forEach((item) => {
        params.push({
          mbfCode: form.getFieldValue('mbfCode') ?? '',
          orderId: id ? id : undefined,
          phoneNumber: Number(item.phoneNumber),
        });
      });
      await checkListSubcriptionInput(params)
        .then((res) => {
          if (res) {
            const newDataSuccess: IListDetailSuccessOrFail[] = [...res.dataSuccess];
            const newDataFailed: IListDetailSuccessOrFail[] = [...res.dataError];
            if (pathFile) {
              setFileImport(null);
              setPathFile('');
              setListSuccess([]);
              setListErros([]);
              setOriSuccess('');
              setOriErros('');
            }

            setListSuccess(newDataSuccess);
            setListErros(newDataFailed);
            setOriSuccess(
              pathFile ? JSON.stringify(res.dataSuccess) : JSON.stringify(newDataSuccess),
            );
            setOriErros(pathFile ? JSON.stringify(res.dataError) : JSON.stringify(newDataFailed));
            setOpenModalConfirmChangeMbfCode(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      message.warning(`Vui lòng chọn gói!`);
    }
  };

  const handleChangeMbfCodeItem = async (data: DataPackage) => {
    const assignSuccess = cloneDeep(listSuccess);
    const dataIndex = assignSuccess.findIndex(
      (predicate) => predicate.phoneNumber === data.phoneNumber,
    );
    const params: ICheckInputSerialParamsRequest = {
      mbfCode: data.mbfCode ?? '',
      orderId: id ? id : undefined,
      phoneNumber: Number(data.phoneNumber),
    };
    checkListSubcriptionInput([params])
      .then((res) => {
        if (res) {
          setPrevMbfCodeReg(res.dataSuccess[0]?.mbfCode);
          if (res?.dataSuccess.length) {
            assignSuccess[dataIndex].mbfCode = res.dataSuccess[0].mbfCode;
            assignSuccess[dataIndex].mbfName = res.dataSuccess[0].mbfName;
            assignSuccess[dataIndex].extraDataObject = {
              cycle: res.dataSuccess[0].cycle,
              dataGb: res.dataSuccess[0].dataGb,
              dataUnit: res.dataSuccess[0].dataUnit,
            };
            assignSuccess[dataIndex].mbfName = res.dataSuccess[0].mbfName;
            assignSuccess[dataIndex].price = undefined;
            assignSuccess[dataIndex].errorCode = res.dataSuccess[0]?.errorCode
              ? res.dataSuccess[0].errorCode
              : '';
            assignSuccess[dataIndex].errorMessage = res.dataSuccess[0]?.errorMessage
              ? res.dataSuccess[0].errorMessage
              : '';
            setListSuccess(assignSuccess);
            setOriSuccess(JSON.stringify(assignSuccess));
          } else if (res?.dataError.length) {
            assignSuccess[dataIndex].mbfCode = previousValueMbfCodeReg.current?.value;
            setListSuccess(assignSuccess);
            setDataItemChangeFail(res?.dataError[0]);
            setOpenModalConfirmChangeFail(true);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChangeMbfFail = () => {
    if (dataItemChangeFail) {
      const newDataSuccess: IListDetailSuccessOrFail[] = [...listSuccess].filter(
        (predicate) => predicate.phoneNumber !== dataItemChangeFail?.phoneNumber,
      );
      const newDataFailed: IListDetailSuccessOrFail[] = [...listErrors, dataItemChangeFail];
      setOriSuccess(JSON.stringify(newDataSuccess));
      setOriErros(JSON.stringify(newDataFailed));
      setListSuccess(newDataSuccess);
      setListErros(newDataFailed);
    }
    setOpenModalConfirmChangeFail(false);
  };

  const handleCancel = async () => {
    try {
      const res = await cancelSubcriptionOrder(id);
      if (res) {
        setOpenModalConfirmCancel(false);
        dispatch(setGlobalState({ refresh: !refresh }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  function normalizePhoneNumber(phone: string) {
    const cleaned = phone.replace(/\D/g, '');

    if (cleaned.startsWith('84')) {
      return cleaned;
    }

    if (cleaned.startsWith('0')) {
      return '84' + cleaned.slice(1);
    }

    return null;
  }

  const handleSearchItem = () => {
    const normalizeValueSearch = normalizePhoneNumber(valueSearch);

    const filterFunc = (item: any) => {
      const matchPhone =
        normalizeValueSearch &&
        (item.phoneNumber?.includes(normalizeValueSearch) ||
          item.userName?.includes(normalizeValueSearch) ||
          item.serial?.includes(normalizeValueSearch) ||
          item.serialNew?.includes(normalizeValueSearch));
      const matchStatus = selectStatus ? selectStatus === item.statusString : true;
      return (normalizeValueSearch ? matchPhone : true) && matchStatus;
    };

    if (activeTab === '2' && oriErros) {
      try {
        setListErros(JSON.parse(oriErros).filter(filterFunc));
      } catch (error) {
        console.log(error);
      }
    } else if (activeTab === '1' && oriSuccess) {
      try {
        setListSuccess(JSON.parse(oriSuccess).filter(filterFunc));
      } catch (error) {
        console.log(error);
      }
    }

    if (!normalizeValueSearch && !selectStatus) {
      try {
        if (activeTab === '2' && oriErros) setListErros(JSON.parse(oriErros));
        if (activeTab === '1' && oriSuccess) setListSuccess(JSON.parse(oriSuccess));
      } catch (error) {
        console.log(error);
      }
    }

    setSearchParams({
      ...searchParams,
      ...params,
      pageIndex: 1,
    });
  };

  const operations = (
    <>
      <div className='flex flex-wrap gap-3 items-center mb-2'>
        <div className='flex items-center gap-2'>
          <span className='text-sm font-medium min-w-[90px]'>Số thuê bao</span>
          <Input
            placeholder='Nhập số thuê bao'
            onChange={(e) => {
              setValueSearch(e.target.value.trim());
            }}
            className='min-w-[150px]'
            allowClear
            size='middle'
          />
        </div>

        <div className='flex items-center gap-2'>
          <span className='text-sm font-medium'>Trạng thái</span>
          <Select
            onSelect={(e) => {
              setSelectStatus(e);
            }}
            className='min-w-[150px]'
            placeholder='Vui lòng chọn'
            size='middle'
            options={[
              {
                value: '',
                label: 'Tất cả',
              },
              {
                value: SimStatusEnum.Success,
                label: 'Success',
              },
              {
                value: SimStatusEnum.Failed,
                label: 'Failed',
              },
            ]}
          />
        </div>

        <div className={`flex gap-3 justify-end ${size.width <= 1024 && 'hidden'}`}>
          <Button
            onClick={() => handleSearchItem()}
            type='primary'
            size='middle'
            className='w-auto'
          >
            Tìm kiếm
          </Button>
          {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.LOAD_DATA_EXPORT_DETAILS) && (
            <Button onClick={() => handleExportTemplate()} size='middle' className='w-auto'>
              Export
            </Button>
          )}
        </div>
      </div>
      <div className={`flex gap-3 justify-end ${size.width > 1024 && 'hidden'} my-3`}>
        <Button onClick={() => handleSearchItem()} type='primary' size='middle' className='w-auto'>
          Tìm kiếm
        </Button>
        {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.LOAD_DATA_EXPORT_DETAILS) && (
          <Button onClick={() => handleExportTemplate()} size='middle' className='w-auto'>
            Export
          </Button>
        )}
      </div>
    </>
  );

  const filterDataSource = (data: any) => {
    let cloneData = JSON.parse(JSON.stringify(data));
    const count = activeTab === '1' ? listSuccess.length : listErrors.length;
    if (
      count == params.pageSize * (params.pageIndex > 1 ? params.pageIndex - 1 : 1) &&
      params.pageIndex > 1
    ) {
      const data = params;
      data.pageIndex = data.pageIndex > 1 ? data.pageIndex - 1 : 1;
      data.pageSize = 10;
      setSearchParams(data);
    }

    cloneData = cloneData.filter((_error: any, index: any) => {
      // debugger
      const pageIndex = params.pageIndex ? parseInt(params.pageIndex) : 1;
      const pageSize = params.pageSize ? parseInt(params.pageSize) : 10;
      if (pageIndex === 1 && index < pageIndex * pageSize) {
        return true;
      } else if (index < pageIndex * pageSize && index >= (pageIndex - 1) * pageSize) {
        return true;
      } else return false;
    });

    return cloneData;
  };

  const columns: IListColumn[] = [
    { name: 'STT', fieldName: 'index', width: 20, isHideSort: true },
    { name: 'SIM serial', fieldName: 'serial', isHideSort: true },
    { name: 'Số thuê bao', fieldName: 'phoneNumber', isHideSort: true },
    {
      name: 'Loại thuê bao',
      fieldName: 'subType',
      isHideSort: true,
      renderSpecialCard: (record) => {
        return <p>{renderSubType('', record?.subType)}</p>;
      },
    },
    {
      name: 'Mã gói đang sử dụng',
      fieldName: 'mbfCodeCurrent',
      isHideSort: true,
      renderSpecialCard: (item: ISubcriptionDataOrderList) => {
        return (
          <span>
            {item && item?.mbfCodeCurrent
              ? item?.mbfCodeCurrent
              : infoPackageInput && infoPackageInput?.mbfCodeCurrent
              ? infoPackageInput?.mbfCodeCurrent
              : ''}
          </span>
        );
      },
    },
    {
      name: 'Mã gói đăng ký',
      fieldName: 'mbfCode',
      isHideSort: true,
      renderSpecialCard: (item: IListDetailSuccessOrFail) => {
        return (
          <Select
            dropdownMatchSelectWidth={false}
            popupClassName='w-[320px] md:w-[500px]'
            showSearch
            placeholder='Vui lòng chọn'
            optionLabelProp='shortLabel'
            options={dataPackage.map((item) => {
              return {
                label: (
                  <Row gutter={16}>
                    <Col span={12} className='text-left'>
                      {item?.mbfCode ?? ''}
                    </Col>
                    <Col span={5}>{item?.dataGb ? `${item?.dataGb} GB` : ''}</Col>
                    <Col span={7} className='text-right'>
                      {item?.cycle ? `${item?.cycle} ngày` : ''}
                    </Col>
                  </Row>
                ),
                value: item?.mbfCode ?? '',
                shortLabel: item?.mbfCode ?? '',
              };
            })}
            value={item.mbfCode}
            disabled={
              statusPackage === OrderStatusEnum.EDIT ||
              (statusPackage === OrderStatusEnum.New && !id)
                ? false
                : true
            }
            onChange={(e) => {
              const findMbf = dataPackage.find((predicate) => predicate.mbfCode === e);
              if (!id) {
                const assignSuccess = cloneDeep(listSuccess);
                const dataIndex = assignSuccess.findIndex(
                  (predicate) => predicate.phoneNumber === item?.phoneNumber,
                );
                assignSuccess[dataIndex].mbfCode = e;
                assignSuccess[dataIndex].mbfName = findMbf?.mbfName;
                assignSuccess[dataIndex].extraDataObject = {
                  cycle: findMbf?.cycle,
                  dataGb: findMbf?.dataGb,
                  dataUnit: findMbf?.dataUnit,
                };
                setListSuccess(assignSuccess);
                setOriSuccess(JSON.stringify(assignSuccess));
              } else {
                handleChangeMbfCodeItem({
                  mbfCode: e,
                  phoneNumber: item.phoneNumber,
                });
              }
            }}
            onFocus={() => {
              previousValueMbfCodeReg.current = {
                item,
                value: prevMbfCodeReg || item.mbfCode,
              };
            }}
          />
        );
      },
    },
    {
      name: 'Tên gói đăng ký',
      fieldName: 'mbfName',
      isHideSort: true,
      renderSpecialCard: (item: IListDetailSuccessOrFail) => {
        return (
          <Select
            dropdownMatchSelectWidth={false}
            popupClassName='w-[320px] md:w-[500px]'
            showSearch
            placeholder='Vui lòng chọn'
            optionLabelProp='shortLabel'
            options={dataPackage.map((item) => {
              return {
                label: (
                  <Row gutter={16}>
                    <Col span={12} className='text-left'>
                      {item?.mbfName ?? ''}
                    </Col>
                    <Col span={5}>{item?.dataGb ? `${item?.dataGb} GB` : ''}</Col>
                    <Col span={7} className='text-right'>
                      {item?.cycle ? `${item?.cycle} ngày` : ''}
                    </Col>
                  </Row>
                ),
                value: item?.mbfCode ?? '',
                shortLabel: item?.mbfName ?? '',
              };
            })}
            value={item.mbfCode}
            labelInValue
            disabled={
              statusPackage === OrderStatusEnum.EDIT ||
              (statusPackage === OrderStatusEnum.New && !id)
                ? false
                : true
            }
            onChange={(e: any) => {
              if (!id) {
                const assignSuccess = cloneDeep(listSuccess);
                const dataIndex = assignSuccess.findIndex(
                  (predicate) => predicate.phoneNumber === item?.phoneNumber,
                );
                const findMbf = dataPackage.find((predicate) => predicate.mbfCode === e.value);
                assignSuccess[dataIndex].mbfCode = e.value;
                assignSuccess[dataIndex].mbfName = findMbf?.mbfName;
                assignSuccess[dataIndex].extraDataObject = {
                  cycle: findMbf?.cycle,
                  dataGb: findMbf?.dataGb,
                  dataUnit: findMbf?.dataUnit,
                };
                setListSuccess(assignSuccess);
                setOriSuccess(JSON.stringify(assignSuccess));
              } else {
                handleChangeMbfCodeItem({
                  mbfCode: e.value,
                  phoneNumber: item.phoneNumber,
                });
              }
            }}
            onFocus={() => {
              previousValueMbfCodeReg.current = {
                item,
                value: prevMbfCodeReg || item.mbfCode,
              };
            }}
          />
        );
      },
    },
    {
      name: 'Dung lượng',
      isHideSort: true,
      renderSpecialCard: (item: IListDetailSuccessOrFail) => {
        return <span>{item.extraDataObject?.dataGb || item?.dataGb}</span>;
      },
    },
    {
      name: 'ĐVT',
      fieldName: 'unit',
      isHideSort: true,
      renderSpecialCard: (item: IListDetailSuccessOrFail) => {
        return <span>{item.extraDataObject?.dataUnit || item?.dataUnit}</span>;
      },
    },
    {
      name: 'HSD',
      fieldName: 'expireDt',
      isHideSort: true,
      renderSpecialCard: (item: IListDetailSuccessOrFail) => {
        return (
          <span>
            {item.extraDataObject?.cycle || item?.cycle
              ? `${item.extraDataObject?.cycle || item?.cycle} ngày`
              : ''}{' '}
          </span>
        );
      },
    },
    {
      name: 'Giá tiền',
      fieldName: 'price',
      isHideSort: true,
      renderSpecialCard: (item: IListDetailSuccessOrFail) => {
        return <span>{formatMoney(item.price || 0)} </span>;
      },
    },
    { name: 'Trạng thái', fieldName: 'statusString', isHideSort: true },
    { name: 'Mã lỗi', fieldName: 'errorCode', isHideSort: true },
    { name: 'Mô tả lỗi', fieldName: 'errorMessage', isHideSort: true },
    {
      name: 'Thao tác',
      renderSpecialCard: (item) => (
        <button
          className={`underline whitespace-nowrap bg-transparent border-transparent text-blue-500 font-semibold ${
            statusPackage === OrderStatusEnum.EDIT ||
            (statusPackage === OrderStatusEnum.New && !order?.id)
              ? 'cursor-pointer'
              : 'opacity-30'
          }`}
          disabled={
            statusPackage === OrderStatusEnum.EDIT ||
            (statusPackage === OrderStatusEnum.New && !order?.id)
              ? false
              : true
          }
          onClick={() => handleDeletePhoneNumber(item)}
        >
          Xóa
        </button>
      ),
      isHideSort: true,
    },
  ];

  const handleDeletePhoneNumber = (dataDelete: ISubcriptionDataOrderList) => {
    let listSuccessTemp = cloneDeep(listSuccess);
    let listErrorsTemp = cloneDeep(listErrors);
    if (activeTab === '1') {
      listSuccessTemp = listSuccessTemp.filter(
        (item) => item?.phoneNumber !== dataDelete.phoneNumber,
      );
    } else {
      listErrorsTemp = listErrorsTemp.filter(
        (item) => item?.phoneNumber !== dataDelete.phoneNumber,
      );
    }
    setListErros(listErrorsTemp);
    setOriErros(JSON.stringify(listErrorsTemp));

    setListSuccess(listSuccessTemp);
    setOriSuccess(JSON.stringify(listSuccessTemp));
  };

  const columnsFail: IListColumn[] = [
    { name: 'STT', fieldName: 'index', width: 20, isHideSort: true },
    { name: 'Số thuê bao', fieldName: 'phoneNumber', isHideSort: true },
    { name: 'Mã lỗi', fieldName: 'errorCode', isHideSort: true },
    { name: 'Lý do', fieldName: 'errorMessage', isHideSort: true },
  ];

  const handleExportTemplate = () => {
    if (Number(activeTab ?? 0) === 1) {
      const link = document.createElement('a');
      link.target = '_blank';
      link.download = `danh_sach_nap_data_${order?.id ?? ''}.xlsx`;
      const url = '/api/SubscriberData/export-excel-detail?type=1';
      exportExcelPost(url, listSuccess).then((res) => {
        link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.ms-excel' }));
        link.click();
      });
    } else {
      const link = document.createElement('a');
      link.target = '_blank';
      link.download = `danh_sach_nap_data_that_bai_${order?.id ?? ''}.xlsx`;
      const url = `/api/SubscriberData/export-excel-detail?type=0`;
      const listErrorsTemp = listErrors.map((callbackfn) => {
        return {
          ...callbackfn,
          errorCode: callbackfn?.code ? callbackfn.code : callbackfn.errorCode ?? '',
          errorMessage: callbackfn?.errorMessage ?? '',
        };
      });
      exportExcelPost(url, listErrorsTemp).then((res) => {
        link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.ms-excel' }));
        link.click();
      });
    }
  };

  const handleExportTemplateImport = () => {
    const link = document.createElement('a');
    link.target = '_blank';
    link.download = `mau_import_nap_data.xlsx`;

    const url = process.env.REACT_APP_API_URL + '/api/Provider/export-excel-template?type=7';
    exportExcel(url)
      .then((res) => {
        link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.ms-excel' }));
        link.click();
      })
      .catch((error) => {
        if (error.status === 403) {
          message.error(`Tài khoản của bạn không có quyền truy cập vào chức năng này`);
        }
      });
  };

  const handleLoadDatacode = async () => {
    await submitSubcriptionData({ orderId: id }).then((res) => {
      if (res) {
        message.success({
          content: 'Hệ thống đang thực hiện nạp data, vui lòng chờ ít phút !',
          duration: 4,
        });
        fetchDetailOrder();
      }
    });
  };

  const handlePayBill = async () => {
    dispatch(
      setModalState({
        open: true,
        content: 'load-data-package-info-pay',
        selectedHistory: { orderId: id, id },
        width: size.width <= 768 ? '95%' : '50%',
      }),
    );
  };

  const confirmReloadData = (callbackOk?: any, callbackCancel?: any) => {
    if (listSuccess.length || listErrors.length) {
      Modal.confirm({
        title: 'Xác nhận',
        icon: <ExclamationCircleOutlined />,
        content: 'Sau khi thêm sẽ xóa dữ liệu trước đó?',
        okText: 'Tiếp tục',
        cancelText: 'Huỷ',
        onOk: () => {
          setListSuccess([]);
          setListErros([]);
          typeof callbackOk === 'function' && callbackOk();
        },
        onCancel: () => {
          typeof callbackCancel === 'function' && callbackCancel();
          setRadio(2);
        },
      });
    } else {
      typeof callbackOk === 'function' && callbackOk();
    }
  };

  return (
    <Fragment>
      <div className='flex  justify-end gap-4 mb-6'>
        {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.LOAD_DATA_CANCEL) && (
          <Button
            type='primary'
            disabled={statusPackage !== OrderStatusEnum.PAYMENT_FAIL}
            onClick={() => setOpenModalConfirmCancel(true)}
          >
            Huỷ
          </Button>
        )}
        {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.LOAD_DATA_PAYMENT_DATA) && (
          <Button
            type='primary'
            disabled={
              statusPackage === OrderStatusEnum.Uncompleted ||
              statusPackage === OrderStatusEnum.Paid
                ? false
                : true
            }
            onClick={handleLoadDatacode}
            className='w-full sm:w-auto'
          >
            Nạp data
          </Button>
        )}
        {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.LOAD_DATA_PAYMENT_ORDER) && (
          <Button
            type='primary'
            disabled={
              [OrderStatusEnum.New, OrderStatusEnum.PAYMENT_FAIL].includes(
                statusPackage as OrderStatusEnum,
              ) && id
                ? false
                : true
            }
            onClick={handlePayBill}
            className='w-full sm:w-auto'
          >
            Thanh toán
          </Button>
        )}
        {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.LOAD_DATA_DELETE) && (
          <Button
            disabled={statusPackage === OrderStatusEnum.New && id ? false : true}
            onClick={() => setOpenModalConfirmDelete(true)}
            danger
            type='primary'
            className='w-full sm:w-auto'
          >
            Xóa
          </Button>
        )}
        {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.LOAD_DATA_CREATE_ORDER) && (
          <Button
            type='primary'
            loading={isLoading}
            onClick={async () => {
              !id && (await form.validateFields(['mbfCode', 'phone_number']));
              if (listSuccess.length > 0) {
                form.validateFields(['mbfCode']).then(() => {
                  handleSubmit();
                });
              } else {
                message.error('Danh sách Nạp data rỗng');
              }
              setIsLoading(true);
              setTimeout(() => {
                setIsLoading(false);
              }, 3000);
            }}
            disabled={
              statusPackage === OrderStatusEnum.EDIT ||
              (statusPackage === OrderStatusEnum.New && !id)
                ? false
                : true
            }
            className='w-full sm:w-auto'
          >
            Lưu
          </Button>
        )}
        {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.LOAD_DATA_PAYMENT_ORDER) && (
          <Button
            disabled={statusPackage === OrderStatusEnum.New && id ? false : true}
            onClick={() => setStatusPackage(OrderStatusEnum.EDIT)}
            className='w-full sm:w-auto'
          >
            Sửa
          </Button>
        )}
      </div>
      <BoxWithLabel title='Thông tin đơn hàng' classNames='mb-6'>
        <Form
          form={form}
          className='mb-8 [&_.ant-form-item-label>label]:font-semibold'
          layout='vertical'
          initialValues={{ type: 'Nạp data', status: '' }}
        >
          <Row gutter={[16, 0]}>
            <Col span={24} md={12} lg={6}>
              <Form.Item label='Mã đơn' name={'id'}>
                <div className='font-medium'>{form.getFieldValue('id')}</div>
              </Form.Item>
              <Form.Item label='Loại đơn hàng' name='type'>
                <Input disabled className='max-w-[300px]' />
              </Form.Item>{' '}
              <Form.Item
                label='Gói'
                rules={[{ required: true, message: 'Vui lòng chọn gói' }]}
                name='mbfCode'
              >
                <Select
                  showSearch
                  placeholder='Vui lòng chọn'
                  options={dataPackage.map((item) => {
                    return {
                      label: (
                        <Row gutter={16}>
                          <Col span={12} className='text-left'>
                            {item?.mbfCode ?? ''}
                          </Col>
                          <Col span={5}>{item?.dataGb ? `${item?.dataGb} GB` : ''}</Col>
                          <Col span={7} className='text-right'>
                            {item?.cycle ? `${item?.cycle} ngày` : ''}
                          </Col>
                        </Row>
                      ),
                      value: item?.mbfCode ?? '',
                    };
                  })}
                  disabled={
                    (statusPackage === OrderStatusEnum.New && !id) ||
                    statusPackage === OrderStatusEnum.EDIT
                      ? false
                      : true
                  }
                  onChange={() => {
                    if (listSuccess.length > 0 || listErrors.length > 0) {
                      if (!id) {
                        handleChangeMbfCode();
                      } else {
                        setOpenModalConfirmChangeMbfCode(true);
                      }
                    }
                  }}
                  onFocus={() => {
                    const currentValue = form.getFieldValue('mbfCode');
                    previousValueMbfCode.current = currentValue;
                  }}
                  className='max-w-[300px]'
                  dropdownMatchSelectWidth={false}
                  popupClassName='w-[320px] md:w-[500px]'
                />
              </Form.Item>
            </Col>
            <Col span={24} md={12} lg={6}>
              <Form.Item label='Tổng cộng' name='countSerial'>
                <div className='font-medium '>{form.getFieldValue('countSerial') || 0}</div>
              </Form.Item>{' '}
              <Form.Item label='Thành công' name='quantitySuccess'>
                <div className='font-medium '>{form.getFieldValue('quantitySuccess') || 0}</div>
              </Form.Item>{' '}
              <Form.Item label='Thất bại' name='quantityFailed'>
                <div className='font-medium '>{form.getFieldValue('quantityFailed') || 0}</div>
              </Form.Item>
            </Col>

            <Col span={24} md={12} lg={6}>
              {currentUrl.includes('data-load') && (
                <Form.Item label='Tổng dung lượng' name='totalData'>
                  <div className='font-medium rounded'>
                    {`${convertNumberByUnit(totalData, 'KB', 'GB')} GB `}
                  </div>
                  <div>{`(tương đương ${totalData.toLocaleString('de-DE')} KB)`}</div>
                </Form.Item>
              )}
              {totalDiscount ? (
                <>
                  <Form.Item label='Tổng tiền' labelCol={{ span: 12 }} name='toTalAmount'>
                    {formatMoney(totalDiscount + form.getFieldValue('toTalAmount'), 'đ')}
                  </Form.Item>
                  <Form.Item label='Chiết khấu' labelCol={{ span: 12 }} name='discount'>
                    {formatMoney(totalDiscount, 'đ')}
                  </Form.Item>
                  <Form.Item label='Thành tiền' labelCol={{ span: 12 }} name='toTalAmount'>
                    {form.getFieldValue('toTalAmount')
                      ? formatMoney(form.getFieldValue('toTalAmount'), 'đ')
                      : ''}
                  </Form.Item>
                </>
              ) : (
                <Form.Item label='Thành tiền' labelCol={{ span: 12 }} name='toTalAmount'>
                  {form.getFieldValue('toTalAmount')
                    ? formatMoney(form.getFieldValue('toTalAmount'), 'đ')
                    : ''}
                </Form.Item>
              )}{' '}
              <Form.Item
                label='Mã GD thanh toán'
                labelCol={{ span: 24, md: 12 }}
                name='transactionId'
              >
                <div className='font-medium '>
                  {form.getFieldValue('transactionId') && (
                    <div
                      className='text-blue-600 underline cursor-pointer'
                      onClick={() =>
                        dispatch(
                          setModalState({
                            open: true,
                            content: 'load-data-package-info-pay',
                            width: size.width <= 768 ? '95%' : '50%',
                            selectedHistory: order,
                          }),
                        )
                      }
                    >
                      <span>{form.getFieldValue('transactionId')}</span>
                    </div>
                  )}
                </div>
              </Form.Item>
              <Form.Item label='Trạng thái' name='statusString'>
                <div className='font-medium'>{form.getFieldValue('statusString')}</div>
              </Form.Item>
            </Col>
            <Col span={24} md={12} lg={6}>
              <Form.Item label='Người tạo' name='createdBy'>
                <div className='font-medium'>{form.getFieldValue('createdBy')}</div>
              </Form.Item>{' '}
              <Form.Item label='Thời gian tạo' name='createdAt'>
                <div className='font-medium'>
                  {form.getFieldValue('createdAt')
                    ? formatDateTime(form.getFieldValue('createdAt'))
                    : ''}
                </div>
              </Form.Item>{' '}
              <Form.Item label='Người cập nhật gần nhất' name='updatedBy'>
                <div className='font-medium'>{form.getFieldValue('updatedBy')}</div>
              </Form.Item>
              <Form.Item label='Thời gian cập nhật gần nhất' name='updatedAt'>
                <div className='font-medium'>
                  {form.getFieldValue('updatedAt')
                    ? new Date(form.getFieldValue('updatedAt')).getTime() ===
                      new Date(form.getFieldValue('createdAt')).getTime()
                      ? ''
                      : formatDateTime(form.getFieldValue('updatedAt'))
                    : ''}
                </div>
              </Form.Item>
            </Col>

            <Col span={24} md={14} lg={12}>
              <Radio.Group
                onChange={(e: RadioChangeEvent) => {
                  confirmReloadData(
                    () => {
                      form.resetFields(['phone_number']);
                      setFileImport(null);
                      setRadio(e.target.value);
                    },
                    () => {
                      setRadio(e.target.value);
                    },
                  );
                }}
                disabled={
                  statusPackage === OrderStatusEnum.EDIT ||
                  (statusPackage === OrderStatusEnum.New && !id)
                    ? false
                    : true
                }
                value={radio}
                className='flex  gap-2 w-full'
              >
                <Radio value={1}>Nhập STB</Radio>
                {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.LOAD_DATA_IMPORT) && (
                  <Radio value={2}>Import file</Radio>
                )}
              </Radio.Group>
              <div className='space-y-4 mt-3'>
                {radio === 1 ? (
                  <div className='flex flex-col sm:flex-row gap-4'>
                    <Form.Item
                      name='phone_number'
                      rules={[
                        { required: true, message: 'Vui lòng nhập số thuê bao' },
                        {
                          min: 10,
                          message: 'Vui lòng nhập đủ số thuê bao',
                        },
                      ]}
                    >
                      <Input
                        type='number'
                        placeholder='Nhập số thuê bao'
                        onChange={(e) => {
                          if (e.target.value.length <= 12) {
                            form.setFieldValue('phone_number', e.target.value);
                          } else {
                            form.setFieldValue('phone_number', e.target.value.substring(0, 12));
                          }
                          e.preventDefault();
                        }}
                        onKeyDown={(evt) => {
                          if (!evt.ctrlKey && !evt.metaKey) {
                            if (
                              evt.key === 'e' ||
                              (!isFinite(Number(evt.key)) && evt.key !== 'Backspace') ||
                              evt.key === '+' ||
                              evt.key === '-' ||
                              evt.key === '.' ||
                              Number(evt.key) > 9 ||
                              Number(evt.key) < 0
                            ) {
                              evt.preventDefault();
                            }
                          }
                        }}
                        disabled={
                          statusPackage === OrderStatusEnum.EDIT ||
                          (statusPackage === OrderStatusEnum.New && !id)
                            ? false
                            : true
                        }
                      />
                    </Form.Item>
                    {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.LOAD_DATA_CHECK_SUBSCRIBER) && (
                      <Button
                        onClick={() => {
                          form
                            .validateFields(['mbfCode', 'phone_number'])
                            .then(() => {
                              addPhoneNumber(form.getFieldValue('phone_number'));
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        }}
                        disabled={
                          statusPackage === OrderStatusEnum.EDIT ||
                          (statusPackage === OrderStatusEnum.New && !id)
                            ? false
                            : true
                        }
                        className='w-full sm:w-auto'
                      >
                        Thêm
                      </Button>
                    )}
                  </div>
                ) : (
                  <div className='space-y-4'>
                    {!fileImport && order?.fileUrl && (
                      <div>
                        <a href={order?.fileUrl} download>
                          <Button
                            type='link'
                            className='[&_span]:break-words [&_span]:max-w-[200px] [&_span]:whitespace-pre-wrap [&_span]:md:max-w-none'
                          >
                            {order?.fileName || 'Excel file'}
                          </Button>
                        </a>
                      </div>
                    )}
                    {fileImport && (
                      <div className='w-[300px] flex items-center gap-2 text-blue-600 underline cursor-pointer hover:text-blue-800 transition'>
                        {fileImport?.name}
                        <DeleteOutlined
                          className='text-red-500 hover:text-red-700'
                          onClick={() => setFileImport(null)}
                        />
                      </div>
                    )}
                    <div className='flex flex-col sm:flex-row gap-4'>
                      <Upload
                        disabled={
                          statusPackage === OrderStatusEnum.EDIT ||
                          (statusPackage === OrderStatusEnum.New && !id)
                            ? false
                            : true
                        }
                        {...props}
                        fileList={fileImport ? [fileImport] : []}
                        showUploadList={false}
                        className='[&_.ant-upload-list-item.ant-upload-list-item-done]:flex-wrap [&_.ant-upload-list-item.ant-upload-list-item-done]:h-fit [&_.ant-upload-list-item-name]:whitespace-pre-wrap [&_.ant-upload-list-item-name]:max-w-[200px] md:[&_.ant-upload-list-item-name]:max-w-none [&_.ant-upload-list-item-name]:p-0 md:[&_.ant-upload-list-item-name]:p-2 [&_.ant-upload-list-item-name]:break-words'
                      >
                        <Button
                          disabled={
                            statusPackage === OrderStatusEnum.EDIT ||
                            (statusPackage === OrderStatusEnum.New && !id)
                              ? false
                              : true
                          }
                          className='w-full sm:w-auto'
                        >
                          Chọn file
                        </Button>
                      </Upload>
                      <Button
                        disabled={
                          (statusPackage === OrderStatusEnum.EDIT ||
                            (statusPackage === OrderStatusEnum.New && !id)) &&
                          fileImport
                            ? false
                            : true
                        }
                        className='w-full sm:w-auto'
                        onClick={() => {
                          handleImport(fileImport);
                        }}
                      >
                        Import
                      </Button>
                      {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.LOAD_DATA_EXPORT_TEMPLATE) && (
                        <Button className='w-full sm:w-auto' onClick={handleExportTemplateImport}>
                          Export template
                        </Button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Form>
      </BoxWithLabel>
      <BoxWithLabel title='Danh sách Thuê bao'>
        {/* <Tabs type='card' items={items} /> */}
        <Tabs
          tabBarExtraContent={size.width > 1024 && operations}
          defaultActiveKey='1'
          type='card'
          size='small'
          onTabClick={(activeKey: string) => {
            setActiveTab(activeKey);
            const data = params;
            data.pageIndex = 1;
            data.pageSize = 10;
            setSearchParams(data);
          }}
          items={new Array(2).fill(null).map((_, i) => {
            const id = String(i + 1);
            return {
              label: id === '1' ? `Danh sách đúng` : 'Danh sách sai',
              key: id,
              children: (
                <div>
                  {size.width <= 1024 && operations}
                  <TableContent
                    scroll={{ x: 'max-content' }}
                    locale={{ emptyText: 'Không tìm thấy kết quả' }}
                    totalRecord={id === '1' ? listSuccess?.length : listErrors?.length}
                    dataSource={
                      id === '1' ? filterDataSource(listSuccess) : filterDataSource(listErrors)
                    }
                    columns={id === '1' ? columns : columnsFail}
                    onChange={(pagination) => {
                      console.log('pagination', pagination);
                    }}
                    onPageChange={(pageNumber, pageSize) => {
                      console.log('pageNumber', pageNumber);
                      console.log('pageSize', pageSize);
                    }}
                    size='small'
                  />
                </div>
              ),
            };
          })}
        />
      </BoxWithLabel>
      <ModalConfirm
        open={openModalConfirm}
        content={
          <div className='p-4 sm:p-8'>
            <div className='font-black text-xl sm:text-3xl mb-4'>Bạn chắc chưa?</div>
            <p className='text-sm sm:text-base'>Sau khi thêm sẽ xóa dữ liệu trước đó</p>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              <Button
                onClick={async () => {
                  try {
                    setIsModalLoading(true);
                    // Import serial
                    if (radio === 1) {
                      await form.validateFields(['mbfCode', 'phone_number']);
                      await addPhoneNumber(form.getFieldValue('phone_number'));
                    }
                    //import excel
                    else {
                      await handleImport(fileImport);
                    }
                    setOpenModalConfirm(false);
                  } catch (error) {
                    console.error(error);
                  } finally {
                    setIsModalLoading(false);
                  }
                }}
                type='primary'
                size='large'
                className='w-full'
                loading={isModalLoading}
              >
                XÁC NHẬN
              </Button>
              <Button
                size='large'
                className='w-full'
                disabled={isModalLoading}
                onClick={() => setOpenModalConfirm(false)}
              >
                THOÁT
              </Button>
            </div>
          </div>
        }
      />
      <ModalConfirm
        open={openModalConfirmDelete}
        content={
          <div className='p-4 sm:p-8'>
            <div className='font-black text-xl sm:text-3xl mb-4'>Xoá đơn hàng?</div>
            <p className='text-sm sm:text-base'>Bạn có chắc chắn muốn xoá đơn hàng Nạp data này?</p>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              <Button
                onClick={handleDeletePackage}
                type='primary'
                danger
                size='large'
                className='w-full'
              >
                XÁC NHẬN
              </Button>
              <Button
                size='large'
                className='w-full'
                onClick={() => setOpenModalConfirmDelete(false)}
              >
                THOÁT
              </Button>
            </div>
          </div>
        }
      />
      <ModalConfirm
        open={openModalConfirmCancel}
        content={
          <div className='p-4 sm:p-8'>
            <div className='font-black text-xl sm:text-3xl mb-4'>Huỷ đơn hàng?</div>
            <p className='text-sm sm:text-base'>Bạn có muốn thực hiện hủy đơn hàng nạp data ?</p>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              <Button onClick={handleCancel} type='primary' size='large' className='w-full'>
                XÁC NHẬN
              </Button>
              <Button
                size='large'
                className='w-full'
                onClick={() => {
                  form.setFieldValue('mbfCode', order?.mbfCode);
                  setOpenModalConfirmCancel(false);
                }}
              >
                THOÁT
              </Button>
            </div>
          </div>
        }
      />
      <ModalConfirm
        open={openModalConfirmChangeMbfCode}
        content={
          <div className='pb-0 p-8'>
            <div className='font-black text-3xl mb-4'>Đổi gói?</div>
            <p>Bạn có chắc chắn muốn đổi gói đơn hàng này?</p>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              <Button
                onClick={async () => {
                  try {
                    setIsChangeMbfCodeLoading(true);
                    await handleChangeMbfCode();
                  } catch (error) {
                    console.log(error);
                  } finally {
                    setIsChangeMbfCodeLoading(false);
                  }
                }}
                type='primary'
                size='large'
                className='w-full'
                loading={isChangeMbfCodeLoading}
              >
                XÁC NHẬN
              </Button>
              <Button
                size='large'
                className='w-full'
                onClick={() => {
                  form.setFieldsValue({
                    mbfCode: previousValueMbfCode.current,
                  });
                  setOpenModalConfirmChangeMbfCode(false);
                }}
                disabled={isChangeMbfCodeLoading}
              >
                THOÁT
              </Button>
            </div>
          </div>
        }
      />
      <ModalConfirm
        open={openModalConfirmChangeFail}
        content={
          <div className='p-4 sm:p-8'>
            <div className='font-black text-xl sm:text-3xl mb-4'>Gói không hợp lệ!</div>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              <Button type='primary' size='large' className='w-full' onClick={handleChangeMbfFail}>
                XÁC NHẬN ĐỔI
              </Button>
              <Button
                size='large'
                className='w-full'
                onClick={() => {
                  const prevDataSuccess = listSuccess.map((item) => {
                    if (item.phoneNumber === previousValueMbfCodeReg.current?.item.phoneNumber) {
                      return {
                        ...item,
                        mbfCode: previousValueMbfCodeReg.current?.value,
                      };
                    }
                    return item;
                  });
                  setListSuccess(prevDataSuccess);
                  setOpenModalConfirmChangeFail(false);
                }}
              >
                HỦY
              </Button>
            </div>
          </div>
        }
      />
    </Fragment>
  );
}

export default CreateLoadDataPackagePage;
